import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";

@Component({
  selector: "app-action-button",
  standalone: true,
  imports: [CommonModule, MatButtonModule],
  templateUrl: "./action-button.component.html",
  styleUrl: "./action-button.component.scss",
})
export class ActionButtonComponent {
  @Input() text: string = "submit";
  @Input() style: string = "flat";
  @Input() disabled: boolean = false;
  @Input() fullWidth: boolean = false;

  @Output() eventTriggered: EventEmitter<void> = new EventEmitter();

  triggerEvent() {
    this.eventTriggered.emit();
  }
}
